import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { fetchWrapper } from "../../../helpers/fetchwrapper";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  Dropdown,
  Field,
  OptionOnSelectData,
  SelectionEvents,
  Option,
  Input,
  TabList,
  Tab,
  MessageBar,
} from "@fluentui/react-components";
import { baseUrl } from "../../../helpers/constants";

const options: { key: string; text: string }[] = [
  {
    key: "ConfigFinderFreigabe",
    text: "Bestätigungsmail für Modul QUICK FINDER & CONFIGURATOR",
  },
  {
    key: "PublicDomain",
    text: "Info Mail aufgrund Public Domain",
  },
  {
    key: "Freitext",
    text: "Freitext",
  },
];

const modules = {
  toolbar: {
    container: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ size: ["small", false, "large", "huge"] }, { color: [] }],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
        { align: [] },
      ],
      ["clean"],
    ],
  },
  clipboard: { matchVisual: false },
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "size",
  "color",
  "list",
  "bullet",
  "indent",
  "align",
];

interface ISendMailProps {
  user: any;
  onEmailSent(): void;
  sendMail: boolean;
  onSaveButtonDiasabled(item: boolean): void;
}

function SendMail(props: ISendMailProps) {
  const [editUser, setEditUser] = useState(props.user);
  const [selectedTabValue, setSelectedTabValue] = useState<string>("Text");
  const [template, setTemplate] = useState({
    content: "",
    subject: "",
    name: "",
  });
  const handleTemplateChange = (name: string, val: any) => {
    setTemplate((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };

  const [error, setError] = useState("");
  const [info, setInfo] = useState("");

  const [mailSent, setMailSent] = useState(false);

  const [templateBody, setTemplateBody] = useState("");

  const getTemplateBody = (lang: string) => {
    fetchWrapper
      .get(baseUrl + "/api/emailtemplate/GetTemplateBody?lang=" + lang)
      .then((result: any) => {
        setTemplateBody(result.body);
      });
  };

  useEffect(() => {
    if (props.user && props.user.sprache) {
      getTemplateBody(props.user.sprache);
    } else {
      getTemplateBody("en");
    }
  }, [props.user]);

  useEffect(() => {
    if (props.sendMail == true) {
      sendMail();
    }
  }, [props.sendMail]);

  useEffect(() => {
    if (template.content == "" || template.subject == "" || mailSent == true) {
      props.onSaveButtonDiasabled(true);
    } else {
      props.onSaveButtonDiasabled(false);
    }
  }, [template.content, template.subject, mailSent]);

  function sendMail() {
    fetchWrapper
      .postWithAuth(`${baseUrl}/api/account/SendMailToUser`, {
        UserId: props.user.id,
        TemplateName: template.name,
        Subject: template.subject,
        Content: template.content,
      })
      .then((result: any) => {
        setInfo(i18n.t<string>("mailSent"));
        setMailSent(true);
        props.onEmailSent();
      })
      .catch((error: any) => {
        setError(error.message ? error.message : "ERROR");
      });
  }

  const onChangeTemplate = (
    event: SelectionEvents,
    data: OptionOnSelectData,
  ) => {
    const key = data.optionValue;
    const language = props.user.sprache
      ? props.user.sprache.includes("de")
        ? "de"
        : "en"
      : "en";

    if (key == "Freitext") {
      setTemplate({
        content: "",
        subject: "LÜBBERING DIGITAL - ",
        name: "Freitext",
      });
      setError("");
    } else {
      fetchWrapper
        .get(
          `${baseUrl}/api/emailtemplate/GetByNameAndLang?name=${key}&lang=${language}`,
        )
        .then((result: any) => {
          // Hier dann Werte ersetzen
          if (result != "") {
            setError("");
            let template = result;
            if (language == "de") {
              template.content = template.content.replace(
                "{anrede}",
                `Sehr geehrte(r) ${props.user.vorname} ${props.user.nachname}`,
              );
            } else {
              template.content = template.content.replace(
                "{anrede}",
                `Dear ${props.user.vorname} ${props.user.nachname}`,
              );
            }

            // Kundenummer ersetzen:
            template.content = template.content.replace(
              "{kundennummer}",
              `${props.user.kundennummer ? props.user.kundennummer : ""}`,
            );

            setTemplate(template);
          } else {
            setTemplate({ name: "", content: "", subject: "" });
            setError("Template nicht gefunden!");
          }
        });
    }
  };
  return (
    <>
      <div className="lueb-ContentBlock">
        {error != "" && <MessageBar intent="error">{error}</MessageBar>}
        {info != "" && <MessageBar intent="success">{info}</MessageBar>}
        <Field label="Template">
          <Dropdown onOptionSelect={onChangeTemplate}>
            {options.map((item) => {
              return <Option value={item.key}>{item.text}</Option>;
            })}
          </Dropdown>
        </Field>
        <Field label="An:">
          <Input readOnly appearance="filled-darker" value={props.user.email} />
        </Field>
        <Field label="Betreff:">
          <Input
            value={template.subject}
            onChange={(ev, data) => {
              handleTemplateChange("subject", data.value);
            }}
          />
        </Field>
      </div>
      <TabList
        onTabSelect={(ev, data) => {
          if (typeof data.value == "string") {
            setSelectedTabValue(data.value);
          }
        }}
        selectedValue={selectedTabValue}
      >
        <Tab value="Text" content={"Text"} />
        {template.name != "" && <Tab value="Vorschau" content={"Vorschau"} />}
      </TabList>
      <div className="lueb-ContentBlock">
        {selectedTabValue == "Text" && (
          <ReactQuill
            style={{ marginTop: "10px" }}
            formats={formats}
            modules={modules}
            theme="snow"
            value={template?.content}
            onChange={(val: any) => handleTemplateChange("content", val)}
          />
        )}
        {selectedTabValue == "Vorschau" && template.name != "" && (
          <div
            dangerouslySetInnerHTML={{
              __html: template
                ? templateBody.replace("{content}", template.content)
                : "<div></div>",
            }}
          />
        )}
      </div>
    </>
  );
}

export default SendMail;
